export const STOCK_COMPRESSED_TEMPLATE_COLUMNS =
  'minmax(85px, 0.25fr) minmax(140px, 0.4fr) minmax(200px, 1fr) minmax(80px, 0.25fr) minmax(9rem, 0.25fr) minmax(9rem, 0.25fr) 6rem';

export const ORDER_COMPRESSED_TEMPLATE_COLUMNS =
  'minmax(85px, 0.25fr) minmax(140px, 0.4fr) minmax(80px, 0.25fr) minmax(250px, 1fr) minmax(7.25rem, 0.3fr) minmax(7.25rem, 0.3fr) minmax(7.25rem, 0.3fr) minmax(7.25rem, 0.3fr) 4rem 5rem 6rem';
